import { IErrMsg } from '../../../components/inputs/types'

export function validateIntegerConstraints(
    value: bigint,
    schema: any
): IErrMsg | undefined {
    try {
        if (typeof schema.greater_or_equal === 'string') {
            const threshold = BigInt(schema.greater_or_equal)
            if (value < threshold) {
                return {
                    message: 'errors.validation.greaterOrEqual',
                    values: { greaterOrEqual: String(schema.greater_or_equal) },
                }
            }
        }

        if (typeof schema.greater_than === 'string') {
            const threshold = BigInt(schema.greater_than)
            if (value <= threshold) {
                return {
                    message: 'errors.validation.greaterThan',
                    values: { greaterThan: String(schema.greater_than) },
                }
            }
        }

        if (typeof schema.less_or_equal === 'string') {
            const threshold = BigInt(schema.less_or_equal)
            if (value > threshold) {
                return {
                    message: 'errors.validation.lessOrEqual',
                    values: { lessOrEqual: String(schema.less_or_equal) },
                }
            }
        }

        if (typeof schema.less_than === 'string') {
            const threshold = BigInt(schema.less_than)
            if (value >= threshold) {
                return {
                    message: 'errors.validation.lessThan',
                    values: { lessThan: String(schema.less_than) },
                }
            }
        }

        return undefined
    } catch {
        return { message: 'errors.validation.invalidSchemaValue' }
    }
}